<script setup lang="ts">
import { hasPermission } from "../../../utils/CommonFunctions";
import { Permission } from "../../../types/auth";
import Buttons from "../form/Buttons.vue";

const props = withDefaults(
  defineProps<{
    readonly: boolean;
    data?: any;
    endPoint: string;
    permissions?: Permission[];
    title: string | null;
    convertModule?: string;
    showText?: boolean;
    showShareIcons?: boolean;
    showNewIcon?: boolean;
    showSaveIcon?: boolean;
    saveNew?: boolean;
  }>(),
  {
    showText: true,
    showSaveIcon: true,
    showShareIcons: true,
    showNewIcon: true,
    saveNew: false,
  }
);

defineEmits<{
  (e: "clear"): void;
  (e: "download"): void;
  (e: "save"): void;
  (e: "saveNew"): void;
  (e: "mail"): void;
  (e: "share"): void;
  (e: "print"): void;
  (e: "new"): void;
  (e: "convert"): void;
  (e: "close"): void;
  (e: "viewDownload"): void;
  (e: "viewMail"): void;
  (e: "viewShare"): void;
  (e: "viewPrint"): void;
}>();
</script>

<template>
  <div
    class="p-2 md:p-2 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3 flex-shrink-0 z-10"
  >
    <slot name="all-buttons"></slot>
    <template v-if="!props.readonly">
      <Buttons
        icon="Plus"
        caption="New"
        @click="$emit('new')"
        v-if="
          hasPermission(props.permissions, 'Create') &&
          props.readonly &&
          props.showNewIcon
        "
      />
      <slot name="write-buttons"></slot>
      <Buttons
        icon="Share2"
        caption="Save"
        @click="$emit('share')"
        v-if="!props.readonly && props.showShareIcons"
      />
      <Buttons
        icon="Mails"
        caption="Save & Email"
        @click="$emit('mail')"
        v-if="!props.readonly && props.showShareIcons"
      />
      <Buttons
        icon="Download"
        caption="Save & Downlaod"
        @click="$emit('download')"
        v-if="!props.readonly && props.showShareIcons"
      />
      <Buttons
        icon="Printer"
        caption="Save & Print"
        @click="$emit('print')"
        v-if="!props.readonly && props.showShareIcons"
      />
      <Buttons
        icon="Save"
        caption="Save"
        @click="$emit('save')"
        v-if="!props.readonly && (props.showShareIcons || props.showSaveIcon)"
      />
      <Buttons
        icon="FilePlus2"
        caption="Save & New"
        @click="$emit('saveNew')"
        v-if="!props.readonly && props.showShareIcons && props.saveNew"
      />
    </template>
    <template v-else-if="props.readonly && props.showShareIcons">
      <slot name="read-buttons"></slot>
      <Buttons icon="Download" caption="Download" @click="$emit('viewDownload')" />
      <Buttons icon="Mails" caption="Email" @click="$emit('viewMail')" />
      <Buttons icon="Share2" caption="Share" @click="$emit('viewShare')" />
      <Buttons icon="Printer" caption="Print" @click="$emit('viewPrint')" />
    </template>
    <Buttons
      icon="FilePlus2"
      caption="NEW"
      @click="$emit('new')"
      v-if="props.readonly && props.showNewIcon"
    />
    <Buttons
      icon="LogOut"
      :caption="props.data ? 'Close' : 'Cancel'"
      @click="$emit('close')"
    />
  </div>
</template>
